<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label" ></fpx-label>
    <div class="fpx-field-content">
      <textarea matInput [formControl]="formControl" [ngClass]="{'input-available': formControl.value}"></textarea>
      <mat-placeholder *ngIf="placeholder" class="placeholder">{{ placeholder }}</mat-placeholder>
    </div>
    <mat-error *ngIf="formControl && formControl.invalid &&  formControl.touched">
      {{errorCode}}
   </mat-error>
</div>
  